module.exports = __webpack_public_path__ + "res/img_reward_m.7ba4bbd39121032c5dbfee1abf36741c.png";